import useUser from '../../../utils/hooks/useUser';
import Avatar from '../../Avatar';

const NewThreadIndicator = () => {
  const user = useUser();

  return <Avatar picture={user.picture} size={16} />;
};

export default NewThreadIndicator;
